<template>
    <div class="modal fade" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel" aria-hidden="true" id="split-modal">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">
                        <i class="fas fa-cut"></i>
                        本文分解
                    </h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="form-group episode-block">
                        <label>
                            前編のタイトル
                            <span v-if="prev">( {{$filters.numberFormat(prev.length)}}文字 )</span>
                        </label>
                        <input type="text" class="form-control" v-model="prev_section_name" placeholder="例）第１話" />
                        <div class="my-2 small" v-if="prev && prev.length" v-html="$filters.ruby(prevPart)"></div>
                        <div class="my-2 text-danger small" v-else>前編に本文がありません。</div>
                    </div>
                    <div class="form-group episode-block">
                        <label>
                            後編のタイトル
                            <span v-if="next">( {{$filters.numberFormat(next.length)}}文字 )</span>
                        </label>
                        <input type="text" class="form-control" v-model="next_section_name" placeholder="例）第２話" />
                        <div class="my-2 small" v-if="next && next.length" v-html="$filters.ruby(nextPart)"></div>
                        <div class="my-2 text-danger small" v-else>後編に本文がありません。</div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-outline-secondary" data-dismiss="modal">閉じる</button>
                    <button type="button" class="btn btn-outline-primary" @click="splitEpisode()" :disabled="noSave">本文を分解する</button>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.episode-block {
    padding: .5rem;
    border: 3px solid #ddd;
    border-radius: .5rem;
}
.episode-part {
    margin: 1rem 0;
}
</style>

<script>
export default {
    props: {
        prev: {
            required: true,
        },
        next: {
            required: true,
        },
        section_name: {
            required: true,
        },
        pos: {
            required: true,
        },
        id: {
            required: true,
        },
    },
    data() {
        return {
            prev_section_name: null,
            next_section_name: null,
        }
    },
    methods: {
        splitEpisode() {
            // 分解実行
            axios.post("/mypage/book/section/split", {
                prev_section_name: this.prev_section_name,
                next_section_name: this.next_section_name,
                pos: this.pos,
                id: this.id,
            }).then(res => {
                alert.msg(res.data);
                $("#split-modal").modal("hide");
                this.$emit("saved");
            }).catch(err => { alert.err(err.response) });
        }
    },
    watch: {
        section_name(n, o) {
            this.prev_section_name = n;
        }
    },
    computed: {
        prevPart() {
            const part = this.prev.replace(/[|｜]|《[^》]+》/gu, "");
            if (part?.length > 200) {
                return "..." + part.substr(-200);
            }
            return part;
        },
        nextPart() {
            const part = this.next.replace(/[|｜]|《[^》]+》/gu, "");
            if (part?.length > 200) {
                return part.substr(0, 200) + "...";
            }
            return part;
        },
        noSave() {
            if (!this.prev?.length || !this.next?.length) {
                return true;
            }
            return false;
        }
    },
    mounted() {
        $("#split-modal").on("show.bs.modal", (e) => {
            this.prev_section_name = this.section_name;
        });
        $("#split-modal").on("hide.bs.modal", (e) => {
            this.prev_section_name = null;
            this.next_section_name = null;
        });
    }
}
</script>